import { render, staticRenderFns } from "./DocumentosPrestador.vue?vue&type=template&id=1c683b19"
import script from "./DocumentosPrestador.vue?vue&type=script&lang=js"
export * from "./DocumentosPrestador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports